import { useEffect, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Image } from 'react-bootstrap';
import { fetchGalleryService } from '../../services/photosService';
import { STORAGE } from '../../utils/headers';

/**
 * Imágenes incluidas en el build. Se usan como respaldo si la API no responde
 * o si todavía no hay ninguna publicada, para que la portada nunca muestre una
 * galería vacía.
 */
const FALLBACK = Array.from({ length: 15 }).map((_, index) => ({
  id: `estatica-${index + 1}`,
  src: `/img/models/${index + 1}.webp`,
  alt: `Modelo de Afrodita Models en Armenia, Quindío (${index + 1})`,
}));

export default function Portfolio() {
  const [photos, setPhotos] = useState(null);
  const [rotas, setRotas] = useState(() => new Set());

  useEffect(() => {
    let activo = true;

    fetchGalleryService()
      .then((data) => {
        if (!activo) return;
        setPhotos(
          Array.isArray(data) && data.length
            ? data.map((photo) => ({
                id: photo.id,
                src: `${STORAGE}/${photo.url}`,
                alt: photo.alt || 'Galería de Afrodita Models',
              }))
            : []
        );
      })
      .catch(() => {
        if (activo) setPhotos([]);
      });

    return () => {
      activo = false;
    };
  }, []);

  // Una imagen que no cargue se retira del carrusel en vez de dejar el hueco
  // roto: el resto de diapositivas conserva su tamaño y separación.
  const marcarRota = (id) => setRotas((prev) => new Set(prev).add(id));

  const slides = useMemo(() => {
    const origen = photos === null || photos.length === 0 ? FALLBACK : photos;
    const visibles = origen.filter((photo) => !rotas.has(photo.id));

    return visibles.length ? visibles : FALLBACK;
  }, [photos, rotas]);

  return (
    <section id="portfolio">
      <div className="container wow fadeInUp">
        <div className="row">
          <div className="col-md-12">
            <h2 className="section-title">Galería</h2>
            <div className="section-title-divider"></div>
          </div>
        </div>
        <div className="row">
        <Swiper         
        effect={'coverflow'}
        grabCursor={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        autoplay={{
          delay:3000,
          disableOnInteraction: true
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination, Autoplay]}
        className="mySwiper"
        >
          {slides.map((photo) => (
            <SwiperSlide key={photo.id}>
              <Image
                src={photo.src}
                alt={photo.alt}
                loading="lazy"
                onError={() => marcarRota(photo.id)}
              />
            </SwiperSlide>
          ))}
      </Swiper>
        </div>
      </div>
    </section>
  );
}
